import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { BsTrash } from "react-icons/bs";
import Swal from "sweetalert2";
import swalWithBootstrapButtons from "sweetalert2-react-content";
import LoadingPageSm from "../../CommonComponent/LoadingPageSm";
import InputLebelComponent from "../../InputLebel/InputLebelComponent";
import removeCertificate from "../../../apis/removeCertificate";
import addCertificate from "../../../apis/addCertificate";
import { useAuthContext } from "../../../context/AuthContext";

const CertificationSetV2 = (props) => {
  const { userDetails } = useAuthContext();
  const user_primary_role = JSON.parse(userDetails).user_primary_role;

  const MySwal = swalWithBootstrapButtons(Swal);
  const { resourceSlug, certificationDetails, displayView } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [certificateSet, setCertificateSet] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [crtText, setCrtText] = useState("");
  const [isAdding, setIsAdding] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = () => {
    setShow(false);
    setShowEdit(true);
  };

  useEffect(() => {
    setIsLoading(false);
    setCertificateSet(certificationDetails);
  }, [certificationDetails]);

  const displayBlockContent = () => {
    if (isLoading) {
      return <LoadingPageSm />;
    } else {
      return renderCertificationSet();
    }
  };

  const renderCertificationSet = () => {
    if (certificateSet !== null && certificateSet) {
      return (
        <>
          {certificateSet.slice(0, 5).map((item, key) => {
            return displayCertificationItem(item, key);
          })}

          <div>
            <span
              className="text-primary cursor-pointer text-sm"
              onClick={() => handleShow()}
            >
              View All Certifications
            </span>
          </div>
          {displayCertificateModalContent()}
        </>
      );
    } else {
      return (
        <div className="mb-3">
          <span className="text-muted">Nothing to display here!</span>
        </div>
      );
    }
  };

  const displayCertificationItem = (item) => {
    return (
      <>
        <span
          key={item.certification_id.toString()}
          className="badge badge-light mb-1 me-1"
          title={item.certification_title.replace(/[^a-zA-Z0-9 ]/g, "")}
        >
          {item.certification_title.length > 22
            ? item.certification_title
                .substr(0, 22)
                .replace(/[^a-zA-Z0-9 ]/g, "") + "..."
            : item.certification_title}
        </span>
      </>
    );
  };

  const displayCertificateEditModalContent = () => {
    return (
      <Modal
        show={showEdit}
        onHide={handleCloseEdit}
        size="Default"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable={true}
        backdrop="static"
      >
        <Modal.Header>
          <div className="d-block">
            <span className="fw-bold-custom">Update Certifications</span>
          </div>
        </Modal.Header>
        <Modal.Body>
          {displayNewAdd()}
          <hr />
          {displayAllCertificatesEditable()}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleCloseEdit} size="sm">
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const handleTextChange = (e) => {
    setCrtText(e.target.value);
  };

  const handleAddNewCrt = () => {
    if (crtText.trim().length > 0) {
      setIsAdding(true);
      processAddNewCrt();
    } else {
      toast.error("Please enter certification name", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const processAddNewCrt = () => {
    setIsAdding(true);
    Promise.all([addCertificate(resourceSlug, crtText)])
      .then(([data]) => {
        if (data?.data?.status) {
          setCrtText("");

          if (certificateSet.length > 0) {
            setCertificateSet((oldArray) => [...oldArray, data.data.crt]);
          } else {
            setCertificateSet([data.data.crt]);
          }

          toast.success(data?.data?.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          toast.warning(data?.data?.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            progress: undefined,
            theme: "light",
          });
        }

        setIsAdding(false);
      })
      .catch((err) => {
        setIsAdding(false);
        console.log(err);
      });
  };

  const displayNewAdd = () => {
    return (
      <div className="d-flex align-items-center">
        <div className="col-6">
          <div className="form-input-holder">
            <InputLebelComponent title="Certification Name" />
            <div className="d-block">
              <input
                type="email"
                className="form-control"
                id="new-skill"
                placeholder="Enter new certification name"
                onChange={handleTextChange}
                value={crtText}
                autoComplete="off"
                disabled={isAdding}
              />
            </div>
          </div>
        </div>
        <div className="col-6 ps-3">
          <Button
            variant="primary"
            onClick={handleAddNewCrt}
            size="sm"
            disabled={isAdding}
          >
            Add Certification
          </Button>
        </div>
      </div>
    );
  };

  const displayCertificateModalContent = () => {
    return (
      <Modal
        show={show}
        onHide={handleClose}
        size="Default"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable={true}
      >
        <Modal.Header>
          <div className="d-block">
            <span className="fw-medium">My Certifications</span>
          </div>
        </Modal.Header>
        <Modal.Body>{displayAllCertificates()}</Modal.Body>
        <Modal.Footer>
          {displayView !== "client" && user_primary_role !== "3" ? (
            <Button
              className="me-3"
              variant="success"
              size="sm"
              onClick={() => handleShowEdit()}
            >
              Update
            </Button>
          ) : null}

          <Button variant="primary" onClick={handleClose} size="sm">
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const displayAllCertificates = () => {
    if (certificateSet !== null && certificateSet) {
      return (
        <>
          <p className="fw-medium">Current Certifications</p>
          <div className="d-flex flex-wrap">
            {certificateSet.map((item, key) => {
              return (
                <span
                  className="badge badge-light mb-1 me-1"
                  key={item.certification_id.toString()}
                >
                  {item.certification_title.replace(/[^a-zA-Z0-9 ]/g, "")}
                </span>
              );
            })}
          </div>
        </>
      );
    } else {
      return <span className="text-muted">Nothing to display here!</span>;
    }
  };

  const remove = (id, name) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "that you want to remove " + name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, remove!",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      confirmButtonColor: "var(--danger)",
      cancelButtonColor: "var(--black)",
    }).then(async (result) => {
      if (result.isConfirmed) {
        processRemove(id);
      }
    });
  };

  const processRemove = (id) => {
    setIsAdding(true);
    Promise.all([removeCertificate(resourceSlug, id)])
      .then(([data]) => {
        if (data?.data?.status) {
          if (certificateSet.length === 1) {
            setCertificateSet(false);
          } else {
            setCertificateSet((current) =>
              current.filter((crt) => crt.certification_id !== id)
            );
          }

          toast.success(data?.data?.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          toast.warning(data?.data?.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            progress: undefined,
            theme: "light",
          });
        }

        setIsAdding(false);
      })
      .catch((err) => {
        setIsAdding(false);
        console.log(err);
      });
  };

  const displayAllCertificatesEditable = () => {
    if (certificateSet !== null && certificateSet) {
      return (
        <>
          <p className="fw-medium">Current Certifications</p>
          <div className="d-flex flex-wrap">
            {certificateSet.map((item, key) => {
              return (
                <button
                  className="btn my-1 me-1 d-flex btn-secondary btn-sm"
                  key={item.certification_id.toString()}
                  disabled={isAdding}
                  onClick={() =>
                    remove(
                      item.certification_id,
                      item.certification_title.replace(/[^a-zA-Z0-9 ]/g, "")
                    )
                  }
                >
                  <span className="fw-normal text-sm">
                    {item.certification_title.replace(/[^a-zA-Z0-9 ]/g, "")}
                  </span>
                  <div className="ms-2 pe-none cursor-pointer">
                    <BsTrash className={`text-light`} />
                  </div>
                </button>
              );
            })}
          </div>
        </>
      );
    } else {
      return (
        <>
          <p className="fw-medium">Current Certifications</p>
          <span className="text-muted text-sm">Nothing to display here!</span>
        </>
      );
    }
  };

  return (
    <>
      <div className="fw-medium mb-2">My Certifications</div>
      {displayBlockContent()}
      {displayCertificateEditModalContent()}
    </>
  );
};

export default CertificationSetV2;
